<script lang="ts">
    export let type:
            | "confirmationButton"
            | "primaryButton"
            | "secondaryButton"
            | "tertiaryButton"
            | "tableButton"
            | "ghostButton"
            | "ghostButtonReverse"
            | "contentLessButton"
            | "tableButtonWithContent"
            | "BubbleButton"
            | "normal",
        icon: string = "",
        disabled = false,
        content: string = "",
        colorForce: string = "",
        noBorder = false,
        noHover = false

    let whiteVersion = false
    if (
        type === "primaryButton" ||
        type === "tableButton" ||
        type === "ghostButton" ||
        type === "tertiaryButton" ||
        type === "BubbleButton" ||
        type === "contentLessButton" ||
        type === "confirmationButton"
    ) {
        whiteVersion = true
    }
    function onMouseeneter() {
        if (noHover) return
        if (type == "secondaryButton") {
            whiteVersion = true
        } else if (type == "tableButton") {
            whiteVersion = false
        } else if (type == "ghostButton") {
            whiteVersion = false
        } else if (type == "tertiaryButton") {
            whiteVersion = false
        } else if (type == "ghostButtonReverse") {
            whiteVersion = true
        } else if (type === "confirmationButton") {
            whiteVersion = true
        } else if (type == "tableButtonWithContent") {
            whiteVersion = true
        } else if (type === "BubbleButton") {
            whiteVersion = false
        }
    }
    function onMouseleave() {
        if (noHover) return
        if (type == "secondaryButton") {
            whiteVersion = false
        } else if (type == "tableButton") {
            whiteVersion = true
        } else if (type == "ghostButton") {
            whiteVersion = true
        } else if (type == "tertiaryButton") {
            whiteVersion = true
        } else if (type == "ghostButtonReverse") {
            whiteVersion = false
        } else if (type === "confirmationButton") {
            whiteVersion = true
        } else if (type == "tableButtonWithContent") {
            whiteVersion = false
        } else if (type === "BubbleButton") {
            whiteVersion = true
        }
    }
</script>

<button
    class="{type} label"
    class:noBorder="{noBorder}"
    class:noHover="{noHover}"
    style="background-color:{colorForce || ''};"
    disabled="{disabled}"
    on:click
    on:mouseenter="{onMouseeneter}"
    on:mouseleave="{onMouseleave}"
    >{#if icon}
        <img
            src="../../../assets/icons/{icon}{whiteVersion ? '-white' : ''}.svg"
            alt="icon"
        />
    {/if}
    {#if content}
        <p>{content}</p>
    {/if}
</button>

<style lang="less">
    @import "../../../assets/variables.less";
    button {
        display: flex;
        padding: 0px 0.7rem;
        justify-content: center;
        align-items: flex-start;
        padding: 0.7rem;
        align-items: center;
        &[disabled] {
            opacity: 0.5;
            pointer-events: none;
        }
        img {
            width: 1.2rem !important;
            height: 1.2rem !important;
        }
        p {
            color: var(--white-100);
            text-transform: uppercase;
        }
        &.primaryButton {
            border-radius: 0.7rem;
            gap: 0.6rem;
            background: var(--red-100);
        }
        &.normal {
            display: flex;
            flex-direction: column;
            gap: 0.6rem;

            padding: 0.7rem 0px !important;
            p {
                color: var(--text-100);
                padding: 0px;
            }
        }
        &.secondaryButton {
            gap: 0.6rem;
            p {
                color: var(--text-100);
            }
            &:not(.noHover):hover {
                p {
                    color: var(--white-100);
                }
                border-radius: 12px;
                background: var(--text-100);
            }
        }
        &.tertiaryButton {
            gap: 0.6rem;
            p {
                color: var(--white-100);
            }
            border-radius: 12px;
            background: var(--text-100);

            &:not(.noHover):hover {
                background: transparent;
                p {
                    color: var(--text-100);
                }
            }
        }
        &.ghostButton {
            flex-direction: column;
            align-items: center;
            gap: 6px;
            padding: 6px 1.2rem;
            border-radius: 12px;
            border: 1px solid var(--white-100);

            p {
                color: white;
                font-weight: 400;
            }
            &:not(.noHover):hover {
                background: white;
                p {
                    color: var(--text-100);
                }
            }
        }
        &.ghostButtonReverse {
            flex-direction: column;
            align-items: center;
            gap: 6px;
            padding: 6px 1.2rem;
            border-radius: 12px;
            border: 1px solid var(--text-100);

            p {
                color: var(--text-100);
                font-weight: 400;
            }
            &:not(.noHover):hover {
                background: var(--text-100);
                p {
                    color: white;
                }
            }
        }
        &.tableButton {
            padding: 6px;
            align-items: center;
            border-radius: 2.4rem;
            background: var(--text-200);
            img {
                height: 0.9rem;
                width: 0.9rem;
            }
            p {
                display: none;
            }
            &:not(.noHover):hover {
                background-color: transparent;
            }
        }
        &.tableButtonWithContent {
            border-radius: 2.4rem;
            border: 1px solid var(--text-100);
            padding: 6px 0.6rem;
            gap: 0.6rem;

            display: flex;
            color: var(--text-100);
            p {
                color: var(--text-100);
            }
            &:not(.noHover):hover {
                background-color: var(--text-100);
                p {
                    color: white;
                }
            }
            @media @mobile {
                width: 100%;
            }
        }
        &.BubbleButton {
            display: flex;
            padding: 6px 0.6rem;
            align-items: center;
            gap: 12px;
            border-radius: 24px;
            background: var(--text-100);
            width: fit-content;
            p {
                color: var(--white-100);
            }
            &:not(.noHover):hover {
                background: transparent;
                p {
                    color: var(--text-100);
                }
            }
        }
        &.confirmationButton {
            border-radius: 0.7rem;
            background: var(--confirm-100);
        }
        &.noBorder {
            border: 0px;
        }
    }
</style>
